import React, { useEffect, useState } from 'react';
import { VideoToFrames, VideoToFramesMethod } from 'utils/VideoToFrame';
import Modal from 'components/shared/modals/Modal'
import Button from 'components/shared/Button';
import clsx from 'clsx';
import Loader from 'components/shared/Loader/Loader';
import styles from './CoverModal.module.scss';

type Props = {
  isOpen: boolean
  onClose: () => void
  videoUrl: any
  setCoverSelectedImage: React.Dispatch<React.SetStateAction<string>>
}

function CoverModal({
  isOpen,
  onClose,
  videoUrl,
  setCoverSelectedImage,
}: Props) {
  const [images, setImages] = useState([]);
  const [isActiveImage, setIsActiveImage] = useState('0')
  const [selectedImage, setSelectedImage] = useState('')

  const getVideo = async () => {
    setImages([]);

    const frames = await VideoToFrames.getFrames(
      videoUrl,
      30,
      VideoToFramesMethod.totalFrames,
    );

    // @ts-ignore
    setImages(frames);
  };

  useEffect(() => {
    getVideo()
  }, [videoUrl])

  useEffect(() => {
    setSelectedImage(images[0])
  }, [images])

  useEffect(() => {
    setIsActiveImage(images[0])
  }, [])

  const handleSelectImage = (imageUrl: string) => {
    setIsActiveImage(imageUrl)
    setSelectedImage(imageUrl)
  }

  const handleSelectCoverImage = () => {
    setCoverSelectedImage(selectedImage)
    onClose()
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      onClick={(e: any) => e.stopPropagation()}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>Cover</h2>
        <div className={styles.mainImage}>
          {selectedImage
          && <img src={selectedImage} data-source={selectedImage} alt={selectedImage} />}
        </div>
        {images?.length > 0 ? (
          <div className={clsx(styles.output, 'scroll')}>
            {images.map((imageUrl) => (
              <div
                className={clsx(styles.imgBlock, isActiveImage === imageUrl ? styles.imgBlockActive : '')}
                key={imageUrl}
                onClick={() => handleSelectImage(imageUrl)}
              >
                <img src={imageUrl} alt="" />
              </div>
            ))}
          </div>
        ) : <Loader /> }
        <Button className={styles.selectBtn} onClick={handleSelectCoverImage}>Select</Button>
      </div>
    </Modal>
  )
}

export default CoverModal
